import { PostSet } from './PostSet';

const exports = {
    PostSet
};

export default exports;
